import CoinCard from './CoinCard';
import { useState } from 'react';
import { IKImage } from 'imagekitio-react';
import { createLeadScore, getProductPricingForCoins } from '../../../redux/actions/pricing';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CoinModal from './CoinModal';
import Timer from '../Timer';
import { useSelector } from 'react-redux';
import CompletionModal from '../CompletionModal';
import { leadScoringActivity } from '../../../common/constants';
import PricingNavbar from '../PricingNavbar';
import { lazy } from 'react';
import { Suspense } from 'react';
import LazySpinner from '../../../components/LazySpinner';
import './index.css'
// import PricingFooter from '../PricingFooter';
const PricingFooter = lazy(()=> import('../PricingFooter'))


const PricingCoins = ({ product_type, discountTime, subscription_type, razorpayHandler, thankyou, coin_id,route }) => {
    const [activeCoinId, setActiveCoinId] = useState(2);
    const [cardDatas, setCardDatas] = useState([]);
    const [isHelp, setIsHelp] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authentication = useSelector(store => store?.authentication);
    const user_id = useSelector(store => store?.profileDetails?.id);
    const [isDiscount, setIsDiscount] = useState(true);
    const [isCompletionModal, setIsCompletionModal] = useState(thankyou === 'true' ? true : false);
    
    function comparator(a , b){
       return b.cost - a.cost;
    }

    useEffect(() => {

        dispatch(getProductPricingForCoins(product_type, subscription_type, async (successObj) =>{
            let sorted_cardData = await (successObj.sort(comparator));
            setCardDatas(sorted_cardData);
        }
        ))
    }, []);

    return (
        <div className="fixed z-10 top-0 bg-[#F5FEFF] left-0 w-screen h-full overflow-y-scroll bg-blue-50 mb-10 flex flex-col items-center">
            <PricingNavbar route={route}/>
            <div className='coinpage-background w-full flex px-4 py-3 items-center md:w-2/3 md:px-8 md:rounded-xl md:mt-8 md:mb-4'
            >
                <div className='flex flex-col items-start md:mr-8 md:justify-center'>
                    <h2 className='text-[#FFF] font-bold text-xs mr-4 md:text-xl md:mt-4'>
                        Want to get <span className='text-[#F59E0B]'>unlimited certifications</span> for free? Upgrade to a pro plan & <span className='text-[#F59E0B]'>upgrade your career!</span>
                    </h2>
                    <button className='bg-[#13B284] text-xs rounded font-bold text-[#FFF] px-2 py-1.5 mt-2 md:my-4 md:py-2 md:px-4 hover:scale-110 transition duration-500 ease-in-out'
                        onClick={()=>navigate('/pricing?type=annual')}
                    >
                        Learn More
                    </button>
                </div>
                <div className='min-w-[100px] max-w-[110px] h-auto md:w-[200px] md:min-w-[150px] md:mx-8'>
                    <img 
                        src="https://assets.learntube.ai/files/PRICING/Group_7042.png?updatedAt=1681988120919" 
                        className='w-full h-auto object-cover'
                        width={'100%'}
                        height={100}
                        alt="student image"
                    />
                </div>
            </div>
            <div className=" w-screen flex flex-col my-4 justify-center items-center">
                <img
                    urlEndpoint="https://assets.learntube.ai/files/"
                    src={"https://assets.learntube.ai/files/PRICING/img5.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658936163618"}
                    transformation={[{
                        "height": "160",
                        "width": "160",
                    }]}
                    className="h-12 mb-3"
                />
                 {/* <div className='flex flex-col mb-4 md:flex-row h-72 md:h-36  w-11/12 md:w-11/12 lg:w-7/12 bg-teal-100 rounded-2xl justify-center md:justify-between pb-2 pl-4 items-center'>
                <img
                    urlEndpoint="https://assets.learntube.ai/files/"
                    src={"https://assets.learntube.ai/files/PRICING/img9.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658936164401"}
                    transformation={[{
                        "height": "160",
                        "width": "160",
                    }]}

                        className="mt-2  md:-mt-0 h-24  md:h-28"
                    />
                    <img
                        urlEndpoint="https://assets.learntube.ai/files/"
                        src={"https://assets.learntube.ai/files/PRICING/img11.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658945410008"}
                        transformation={[{
                            "height": "160",
                            "width": "160",
                        }]}

                    className="mt-8 md:mt-2 mr-5 w-11/12 mb-7 md:mb-0 md:w-1/2 md:h-10 md:h-32"
                />
                <div className='flex flex-col'>
                    <button className='bg-gradient-to-r from-pricing_blue to-cyan-500 h-10 w-40 rounded-3xl font-bold text-white text-xs mr-1.52' onClick={(event) => { navigate('/pricing') }}>Upgrade to Pro</button>
                    <div className='text-xs font-bold ml-2 mt-1'>Starting at Rs 99/ Month</div>
                </div>
            </div> */}
                <h1 className=' text-lg mb-4 text-center font-bold mt-2'>Purchase Coins & Use Them to Unlock</h1>
                <div className='flex flex-col md:w-2/3 md:gap-4 md:flex-row justify-around items-center'>
                    <div className='flex rounded-lg w-full bg-white px-2 border-2 h-9 mb-2 md:mb-0 border-gray-200 gap-1 justify-center items-center whitespace-nowrap'>
                        <div>
                            <img src="https://assets.learntube.ai/files/PRICING/img10.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658938810160" width={20} height={20} alt="tick mark" />
                        </div>
                        {/* <img
                            urlEndpoint="https://assets.learntube.ai/files/"
                            src={"https://assets.learntube.ai/files/PRICING/img10.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658938810160"}
                            transformation={[{
                                "height": "160",
                                "width": "160",
                            }]}
                            className=" mb-3"

                        /> */}
                        <h4 className="text-sm font-medium ml-2 ">Verified Certification for Your Skills</h4>
                    </div>
                    <div className='flex rounded-lg w-full bg-white px-2 border-2 h-9  mb-2 md:mb-0 border-gray-200 gap-1 justify-center items-center whitespace-nowrap'>
                        <div>
                            <img src="https://assets.learntube.ai/files/PRICING/img10.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658938810160"  width={20} height={20} alt="tick mark"  />
                        </div>
                        {/* <img
                            urlEndpoint="https://assets.learntube.ai/files/"
                            src={"https://assets.learntube.ai/files/PRICING/img10.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658938810160"}
                            transformation={[{
                                "height": "160",
                                "width": "160",
                            }]}
                            className=" mb-3"
                        /> */}
                        <h4 className="text-sm font-medium ml-2 mr-6 md:mr-0 ">24 Hours Expert Doubt Solving</h4>
                    </div>
                    <div className='flex rounded-lg w-full mb-2 bg-white px-2 border-2  h-9  border-gray-200 gap-1 justify-center items-center whitespace-nowrap md:mb-0'>
                        <div>
                            <img src="https://assets.learntube.ai/files/PRICING/img10.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658938810160"  width={20} height={20} alt="tick mark" />
                        </div>

                        {/* <img
                            urlEndpoint="https://assets.learntube.ai/files/"
                            src={"https://assets.learntube.ai/files/PRICING/img10.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658938810160"}
                            transformation={[{
                                "height": "160",
                                "width": "160",
                            }]}
                            className=" mb-3"
                        /> */}
                        <h4 className="text-sm font-medium ml-2">Unlimited Access to Whatsapp Bot</h4>
                    </div>
                </div>
            </div>
            <div className=" mt-10  flex flex-col w-10/12 md:w-2/3 md:flex-row md:justify-center md:items-center  ">
                {
                    cardDatas.map((cardData) => <CoinCard isDiscount={isDiscount} razorpayHandler={razorpayHandler} cardData={cardData} id={cardData?.sort_order} product_name={cardData?.product_name} cost={cardData?.cost} url={cardData?.pp_product_image_url} isCardEnabled={activeCoinId === cardData?.sort_order} setIsCardEnabled={setActiveCoinId}></CoinCard>)
                }
            </div>
            <div className='bg-[#CCFBF1] w-[90%] pb-2 pt-3 px-3 rounded-lg mb-5 md:hidden' style={{
                backgroundImage: `url('https://assets.learntube.ai/files/PRICING/image_46__1_.svg?updatedAt=1681996337633')`,
                backgroundRepeat: 'no-repeat',
                backgroundSize:'36.5%', 
                backgroundPosition: 'right bottom'
            }}>
                <h2 className='text-2xl mb-3 font-medium'>Upgrade to <span className='font-bold text-[#2BBD13]'>Pro</span> at <span className='font-bold text-[#2BBD13]'>&#8377;299</span></h2>
                <div className='flex items-center mb-3'>
                    <div className='mr-1.5'>
                        <img src="https://assets.learntube.ai/files/PRICING/Group_5837.svg?updatedAt=1681993990247" width={24} height={24} alt="tick mark" />
                    </div>
                    <p className='text-sm font-medium'>Unlimited access to <span className='font-bold text-[#2BBD13]'>200+ courses</span></p>
                </div>
                <div className='flex items-start mb-3'>
                    <div className='mr-1.5'>
                        <img src="https://assets.learntube.ai/files/PRICING/Group_5837.svg?updatedAt=1681993990247" width={24} height={24} alt="tick mark" />
                    </div>
                    <p className='text-sm font-medium'>Get unlimited certificates without coins</p>
                </div>
                <div className='flex items-center mb-3'>
                    <div className='mr-1.5'>
                        <img src="https://assets.learntube.ai/files/PRICING/Group_5837.svg?updatedAt=1681993990247" width={24} height={24} alt="tick mark" />
                    </div>
                    <p className='text-sm font-medium'>Live networking</p>
                </div>
                <div className='flex items-center mb-3'>
                    <div className='mr-1.5'>
                        <img src="https://assets.learntube.ai/files/PRICING/Group_5837.svg?updatedAt=1681993990247" width={24} height={24} alt="tick mark" />
                    </div>
                    <p className='text-sm font-medium'>Recommended courses</p>
                </div>
                <button className='bg-[#13B284] w-[12rem] h-[2.5rem] text-base rounded-lg font-bold text-[#FFF] px-3 py-1 mb-9 mt-6 hover:scale-110 transition duration-500 ease-in-out'
                    onClick={()=>navigate('/pricing?type=annual')}
                >
                    Learn More
                </button>
            </div>
            <div className='bg-[#CCFBF1] w-[675px] rounded-lg mb-10 mt-7 hidden md:inline-block' style={{
                backgroundImage: `url('https://assets.learntube.ai/files/PRICING/img9.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658936164401')`,
                backgroundRepeat: 'no-repeat',
                backgroundSize:'37%',
                backgroundPosition: 'left bottom'
            }}>
                <div className='w-1/2 h-full inline-block float-right mr-8 mt-6'>
                    <h2 className='text-2xl mb-3 font-medium'>Upgrade to <span className='font-bold text-[#2BBD13]'>Pro</span> at <span className='font-bold text-[#2BBD13]'>&#8377;299</span></h2>
                    <div className='flex items-center mb-3'>
                        <div className='mr-1.5'>
                            <img src="https://assets.learntube.ai/files/PRICING/Group_5837.svg?updatedAt=1681993990247"  width={20} height={20} alt="tick mark" />
                        </div>
                        <p className='text-base font-medium'>Unlimited access to <span className='font-bold text-[#2BBD13]'>200+ courses</span></p>
                    </div>
                    <div className='flex items-start mb-3'>
                        <div className='mr-1.5'>
                            <img src="https://assets.learntube.ai/files/PRICING/Group_5837.svg?updatedAt=1681993990247"  width={20} height={20} alt="tick mark" />
                        </div>
                        <p className='text-base font-medium'>Get unlimited certificates without coins</p>
                    </div>
                    <div className='flex items-center mb-3'>
                        <div className='mr-1.5'>
                            <img src="https://assets.learntube.ai/files/PRICING/Group_5837.svg?updatedAt=1681993990247"  width={20} height={20} alt="tick mark" />
                        </div>
                        <p className='text-base font-medium'>Live networking</p>
                    </div>
                    <div className='flex items-center mb-3'>
                        <div className='mr-1.5'>
                            <img src="https://assets.learntube.ai/files/PRICING/Group_5837.svg?updatedAt=1681993990247"  width={20} height={20} alt="tick mark" />
                        </div>
                        <p className='text-base font-medium'>Recommended courses</p>
                    </div>
                    <button className='bg-[#13B284] w-[13rem] h-[2.5rem] text-sm rounded font-bold text-[#FFF] px-2 py-1 mb-6 mt-2 ml-16 hover:scale-110 transition duration-500 ease-in-out'
                        onClick={()=>navigate('/pricing?type=annual')}
                    >
                        Learn More
                    </button>
                </div>
            </div>

            <h1 className=' mt-4 md:mt-10 mb-3 text-md font-medium'>Need Help?&nbsp;<a className="text-pricing_blue cursor-pointer font-semibold" onClick={(event) => {
                setIsHelp(!isHelp);
                dispatch(createLeadScore(user_id, leadScoringActivity.REQUESTED_HELP.type))
            }}>Talk to a Career Expert</a></h1>
            {
                isHelp && <CoinModal isModalEnabled={isHelp} setIsModalEnabled={setIsHelp}></CoinModal>
            }

            {
                authentication !== null && <Timer countDownDate={discountTime} type="coin" setIsDiscount={setIsDiscount} />
            }
            {
                isCompletionModal && <CompletionModal isModalEnabled={isCompletionModal} setIsModalEnabled={setIsCompletionModal} type={'coin'} coin_id={coin_id}></CompletionModal>

            }
           
           <Suspense fallback={LazySpinner}> <PricingFooter/></Suspense>

        </div>)

}

export default PricingCoins
